import React, { memo, useMemo } from 'react'
import { IActivityStatusUpdated, IActivitySubtextBaseProps } from 'apps/fleet-planner/types'
import { ContextCard } from 'transfix-ui'

export interface IActivitySubtextSubscriberProps
  extends IActivitySubtextBaseProps<IActivityStatusUpdated> {}

export const ActivitySubtextSubscriber = memo<IActivitySubtextSubscriberProps>(({ activity }) => {
  const { metadata } = activity || {}
  const { subscribers = [] } = metadata || {}
  const subscriberCount = subscribers?.length || 0

  const getTriggerText = () => {
    return (
      <span className='load-details-activity-subtext-subscriber-trigger'>{`${subscriberCount} ${
        subscriberCount > 1 ? 'people' : 'person'
      }`}</span>
    )
  }

  // Retain the same instance of text, so we don't trigger a re-render.
  const triggerText = useMemo(() => getTriggerText(), [])

  const getSubtext = () => {
    return (
      <ContextCard triggerText={triggerText}>
        <div>
          {subscribers?.map(subscriber => {
            const { email, name } = subscriber || {}
            return (
              <div key={email} className='pt2'>
                {name && <div>{name}</div>}
                <div className={`${name ? 'subscribers-row-subtext' : ''} fs-mask`}>{email}</div>
              </div>
            )
          })}
        </div>
      </ContextCard>
    )
  }

  // If there are 0 subscribers, we won't display this row
  if (subscriberCount) {
    return (
      <div>
        {getSubtext()}{' '}
        <span className='load-details-activity-subtext-subscriber'>{`${
          subscriberCount === 1 ? 'was' : 'were'
        } notified.`}</span>
      </div>
    )
  }
  return <></>
})
